"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotImplemented = void 0;
const ResponseError_1 = require("./ResponseError");
class NotImplemented extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || NotImplemented.label;
        this.type = NotImplemented.type;
        this.statusCode = NotImplemented.statusCode;
        Error.captureStackTrace(this, NotImplemented);
    }
}
exports.NotImplemented = NotImplemented;
NotImplemented.type = 'NotImplemented';
NotImplemented.label = 'Not Implemented';
NotImplemented.statusCode = 501;
//# sourceMappingURL=NotImplemented.js.map